import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import produce, { immerable } from 'immer';
import { Map, Set } from 'immutable';

import { MapItemEntity } from './map-item.entity';

export interface IMapListExtra extends IListColumnConfig<MapItemEntity> {
	width?: string | number;
	filterValue?: Array<string | number>;
	filterValues?: Array<string | number>;
	sortIndex?: number;
	sortOrder?: 'asc' | 'desc';
}

interface IMapListEntity extends IListAttrs<MapItemEntity> {
	availableColumns: Map<string, IMapListExtra>;
}

const entityDefaults: IMapListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class MapListEntity
	implements IMapListEntity, IListOperations<MapListEntity, MapItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(availableCols: Array<IMapListExtra>): MapListEntity {
		const instance = new MapListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IMapListExtra]>());

		instance.availableColumns = Map(cols);
		return instance;
	}

	private constructor() {}

	public getAvailableColumns(): Map<string, IListColumnConfig<MapItemEntity>> {
		return this.availableColumns;
	}

	public setElements(elems: Map<string, MapItemEntity>): MapListEntity {
		return produce(this, (draft: MapListEntity) => {
			draft.elements = elems;
		});
	}

	public extractUniqTags(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, mapItem) => {
			if (!mapItem.tags) {
				return acc;
			}
			return Set([
				...acc.toArray(),
				...mapItem.tags
					.toList()
					.toArray()
					.map((l) => l.label),
			]);
		}, Set<string>(startValues));
	}

	public extractModifiers(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, mapItem) => {
			if (mapItem.updatedByAvatar && mapItem.updatedByAvatar?.name) {
				acc = acc.add(mapItem.updatedByAvatar.name);
			}
			return acc;
		}, Set<string>(startValues));
	}

	public extractActionCreators(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, mapItem) => {
			if (mapItem.createdByAvatar && mapItem.createdByAvatar.name) {
				acc = acc.add(mapItem.createdByAvatar.name);
			}
			return acc;
		}, Set<string>(startValues));
	}
}
